import aboutYou from 'purchase/checkout/aboutYou';
import CheckoutPaymentMethods from 'purchase/checkout/CheckoutPaymentMethods';
import SameAsDeliveryCheckBox from 'purchase/checkout/sameAsDeliveryCheckBox';
import formListener from 'purchase/checkout/addressFormListener';
import formOptionalFields from 'purchase/checkout/formOptionalFields';
import highlightFieldFromReason from 'purchase/checkout/highlightFieldFromReason';
import {
	DeliveryAddressManager,
	canInitialise,
} from 'purchase/checkout/AddressManagement/DeliveryAddressManager';
import ReviewStepFormControl from 'purchase/checkout/ReviewStepFormControl';
import coreMetricsDeliveryStep from 'purchase/checkout/delivery';
import OrderPending from 'purchase/checkout/orderPending';
import CheckoutEnterDeliveryUpdatesEmailCheckBox from 'purchase/checkout/checkoutEnterDeliveryUpdatesEmail';
import sessionTimeoutLogoutFlow from 'global/common/sessionTimeoutLogoutFlow';
import DeliveryDateChange from 'purchase/checkout/deliveryDateChange';
import OptionalReferenceChange from 'purchase/checkout/optionalReferenceChange';
import initBillingFormInvoiceEmailValidation from 'purchase/checkout/billingFormInvoiceEmailValidation';
import initPeppolDropdownLogic from 'purchase/checkout/initPeppolDropdownLogic';
import BillingFormController from './checkout/billingPage/BillingFormController';
import BraintreePaymentServiceProvider from './checkout/BraintreePayment/BraintreePaymentServiceProvider';

new OptionalReferenceChange();
new DeliveryDateChange();

new SameAsDeliveryCheckBox();
new CheckoutEnterDeliveryUpdatesEmailCheckBox();
aboutYou();
new CheckoutPaymentMethods();
formListener().init();
formOptionalFields();
highlightFieldFromReason();
if (canInitialise()) {
	new DeliveryAddressManager();
}

// Session Timeout
sessionTimeoutLogoutFlow();

const reviewStepForm = document.getElementById('orderReviewForm');
if (reviewStepForm) {
	ReviewStepFormControl.initTermsAndConditionsCheckboxValidationEvent();
	new ReviewStepFormControl(reviewStepForm);
}

new BraintreePaymentServiceProvider();

const billingForm = document.getElementById('billingForm');
if (billingForm) {
	if (window.od?.isInvoiceExperianCheckActive) {
		initBillingFormInvoiceEmailValidation();
	}
	initPeppolDropdownLogic();
	new BillingFormController();
}

coreMetricsDeliveryStep();

if (document.getElementById('orderConfirmation')) {
	new OrderPending();
}
